import { createColumnHelper } from '@tanstack/react-table';

import { checkIsUrl } from '@ballerine/common';

import { BallerineLink } from '@/components/atoms/BallerineLink';
import { TextWithNAFallback } from '@/components/atoms/TextWithNAFallback';

const columnHelper = createColumnHelper<{
  domain: string;
  relatedNodeType: string;
  relatedNode: string;
}>();

export const columns = [
  columnHelper.display({
    id: 'index',
    header: 'Number',
    cell: info => {
      const index = info.cell.row.index + 1;

      return (
        <div className="w-16 min-w-16 max-w-16">
          <TextWithNAFallback className={`truncate ps-8`}>{index}</TextWithNAFallback>
        </div>
      );
    },
  }),
  columnHelper.accessor('domain', {
    header: 'Domain',
    cell: info => {
      const domain = info.getValue();
      const addProtocolIfMissing = (url: string) => {
        if (url.startsWith('http://') || url.startsWith('https://')) {
          return url;
        }

        return `http://${url}`;
      };
      const domainWithProtocol = addProtocolIfMissing(domain);

      if (checkIsUrl(domainWithProtocol)) {
        return (
          <div className="w-40 min-w-0 max-w-40 px-2">
            <BallerineLink
              href={domainWithProtocol}
              className="block justify-start truncate"
              title={domain}
            >
              {domain}
            </BallerineLink>
          </div>
        );
      }

      return (
        <div className="w-40 min-w-0 max-w-40 px-2">
          <TextWithNAFallback className="block truncate" title={domain}>
            {domain}
          </TextWithNAFallback>
        </div>
      );
    },
  }),
  columnHelper.accessor('relatedNodeType', {
    header: 'Related Node Type',
    cell: info => {
      const relatedNodeType = info.getValue();

      return (
        <div className="w-32 min-w-0 max-w-32">
          <TextWithNAFallback className="truncate">{relatedNodeType}</TextWithNAFallback>
        </div>
      );
    },
  }),
  columnHelper.accessor('relatedNode', {
    header: 'Related Node',
    cell: info => {
      const relatedNode = info.getValue();

      return (
        <div className="min-w-0 max-w-96 px-2">
          <TextWithNAFallback
            className="line-clamp-3 block whitespace-pre-wrap break-words"
            title={relatedNode}
          >
            {relatedNode}
          </TextWithNAFallback>
        </div>
      );
    },
  }),
];
